import type { DBRecord } from '../services/PreferencesDB.ts';

export interface Point {
  x: number;
  y: number;
}

export class Headache implements DBRecord {
  id: string = crypto.randomUUID();
  createdAt: number = Date.now();
  lastModified: number = Date.now();
  intensity: number = 5;
  zones: string[] = [];
  note: string = '';

  toPlain(): object {
    return {
      id: this.id,
      createdAt: this.createdAt,
      lastModified: this.lastModified,
      intensity: this.intensity,
      zones: this.zones,
      note: this.note,
    };
  }
}
